import { z } from 'zod';

export type BackgroundCheckTypeJnet = 'PA_JNET_MAN_SUBMIT';

export const jnetBackgroundCheckTypes = {
    jnet: {
        jasType: 'PA_JNET_MAN_SUBMIT',
    },
} as const;

export const intellicorpBackgroundCheckTypes = {
    manual: {
        jasType: undefined,
    },
    criminalSuper: {
        jasType: 'LEGACY',
    },
    legacySexOffender: {
        jasType: 'LEGACY_SEXOFFENDER',
    },
    standard: {
        jasType: 'STANDARD',
    },
    cori: {
        jasType: undefined,
    },
    vsos: {
        jasType: 'LEGACY_SEXOFFENDER',
    },
    patch: {
        jasType: undefined,
    },
} as const;

export const backgroundCheckTypes = {
    ...jnetBackgroundCheckTypes,
    ...intellicorpBackgroundCheckTypes,
} as const;

export const intellicorpBackgroundCheckTypesSchema = z.enum(
    Object.keys(intellicorpBackgroundCheckTypes) as [
        keyof typeof intellicorpBackgroundCheckTypes,
        ...Array<keyof typeof intellicorpBackgroundCheckTypes>,
    ],
);

export const jnetBackgroundCheckTypesSchema = z.enum(
    Object.keys(jnetBackgroundCheckTypes) as [keyof typeof jnetBackgroundCheckTypes, ...Array<keyof typeof jnetBackgroundCheckTypes>],
);

export const backgroundCheckTypeSchema = z.union([intellicorpBackgroundCheckTypesSchema, jnetBackgroundCheckTypesSchema]);

export type IntellicorpBackgroundCheckType = z.infer<typeof intellicorpBackgroundCheckTypesSchema>;

export type BackgroundCheckType = z.infer<typeof backgroundCheckTypeSchema>;

export const backgroundCheckStatuses = {
    completeClear: 'Complete: Clear - No Matches Found',
    completeDenied: 'Complete: Denied',
    didNotConsent: 'Did Not Consent',
    formIncomplete: 'Form Incomplete',
    invalidSsn: 'Review and Take Action: Invalid SSN',
    missingFields: 'Required Fields Are Missing or Invalid',
    processingError: 'Processing: Error',
    processingNeedsAttention: 'Processing: Needs Attention',
    processingPending: 'Processing: Submission Pending',
    processingResearching: 'Processing: Researching',
    processingSubmitted: 'Processing: Submitted',
    readyToSubmit: 'Ready to Submit',
    reviewAndTakeAction: 'Review and Take Action: Possible Matches Found',
    unknown: 'Unknown',
} as const;

export const backgroundCheckStatusesSchema = z.enum(
    Object.keys(backgroundCheckStatuses) as [keyof typeof backgroundCheckStatuses, ...Array<keyof typeof backgroundCheckStatuses>],
);
export type BackgroundCheckStatus = z.infer<typeof backgroundCheckStatusesSchema>;
